// extracted by mini-css-extract-plugin
export default {"cookieBanner":"styles_cookieBanner__Yjn9o","wrapper":"styles_wrapper__L0AtM","policy":"styles_policy__qoxna"};